module.exports = __webpack_public_path__ + "e3e7be029c2c8080b7f3a5d1bdb8950c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-3.png
// module id = 2505
// module chunks = 0